import {
  Row, Col, Table, Card, message, Button,


} from 'antd';
import { useEffect, useState } from 'react';
import { DeleteOutlined } from "@ant-design/icons"
import { useSelector, useDispatch } from 'react-redux';
import ProposedBadge from '../components/badge';
import SearchBox from '../components/SearchBox';
import moment from "moment";
import { financialYearTypes, periodTypes, query_type, user_role } from '../consts';
import PermissionModal from '../components/PermissionModal';
import { Loader } from "../components/loader";
import { useNavigate, useParams } from "react-router-dom";
import { priority_order, fy_status_order } from "../consts";
import FYPrioritySelector from "../components/prioritySelector";
import FYStatusSelector from "../components/FYStatus";
import Fyassign from "../components/querySidebar/fyAsing";
import { useGetAllFinancialYears, useGetAllQueries, useGetAllUsers, useUpdateFinancialYear, useDeleteFinancialYear } from '../utils/queryUtils';
import { setReloadFinancialYear } from '../store/action/reload';
import { normalizeString } from '../utils/pathUtils';


export default function FinancialyearsCache() {
  const { companyName, clientName } = useParams();
  let dispatch = useDispatch();
  const [, setPageSize] = useState(10);
  const { reloadFY } = useSelector(st => {
    return st.reload
  })
  const placeholder = "Search Financial Years..."
  const [, setShow] = useState([]);
  const [permissionModalOpen, setPermissionModalOpen] = useState(null);
  const selectedPrimaryClient = useSelector(st => st.selected.primaryClient);
  const [showData] = useState([]);
  const [tableFilters, setTableFilters] = useState({
    "entity": [],
    "priority": [],
    "assigned_to": [],
    "period_type": [],
    "fy_type": [],
    status: ['OPEN', 'CLOSED', 'QUERIES PENDING', 'QUERIES RESOLVED']
  });
  const [fyy, setFyy] = useState("");
  const user = useSelector(st => st.user)
  const statusFilters = fy_status_order?.map((e) => ({ text: e, value: e }));
  const priorityFilters = priority_order?.map((e) => ({ text: e, value: e }));
  const periodFilters = periodTypes?.map((e) => ({ text: e, value: e }));
  const fyTypeFilters = financialYearTypes?.map((e) => ({ text: e, value: e }));
  const navigate = useNavigate();
  const { client, company } = useSelector(st => {
    return st.selected
  })
  const { company: selectedCompany } = useSelector(st => st.selected)
  // const { data: financialYearsCache, isLoading } = useGetAllFinancialYears(client?._id);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const financialYearCache = useGetAllFinancialYears(client, company?._id, pagination.current, tableFilters, selectedPrimaryClient);
  const [isLoading, setIsLoading] = useState(false);
  const financialYears = financialYearCache.data;
  const { data: users } = useGetAllUsers()
  const { data } = useGetAllQueries();
  const query = data?.data;
  const { mutateAsync: deleteFy, } = useDeleteFinancialYear()

  const { mutateAsync: updateFinancialYear, isSuccess: isUpdateSuccess } = useUpdateFinancialYear();
  const handleTableChange = (pagination, filters) => {
    try {
      setPagination((prev) => ({
        ...prev,
        current: pagination.current,
      }));
      setPageSize(pagination?.pageSize);
      setTableFilters((prev) => {
        return prev = { ...prev, ...filters }
      })
    }
    catch (err) {
      console.error(err)
    }
  };
  const handleFyUpdate = async (update) => {
    try {
      const payload = {
        ...update,
        clientName: client?._id,
        page: pagination.current,
        filters: tableFilters,
        fy: fyy,
      };
      await updateFinancialYear(payload);
    } catch (e) {
      console.error(e);
      message.error("Some error occurred while updating assigned to");
    }
  };

  const handlePriorityUpdate = async (item, newPriority) => {
    if (item.priority !== newPriority) {
      try {
        const payLoad = {
          fy: item._id,
          priority: newPriority,
          clientName: item.client_id,
          companyName: item.company_id,
          page: pagination.current,
          filters: tableFilters,
          all: false
        };
        await updateFinancialYear(payLoad);
        if (isUpdateSuccess) {
          message.success("Priority updated successfully");
        }
      } catch {
        message.error("Some error occurred while updating priority");
      }
    }
    return;
  };
  const { reloadFinancialYear } = useSelector(st => {
    return st.reload
  })
  useEffect(() => {
    if (financialYears) {
      setPagination((prev) => ({
        ...prev,
        current: financialYears?.pagination?.current,
        total: financialYears?.pagination?.total,
      }));

    }
  }, [financialYears]);
  useEffect(() => {
    financialYearCache.refetch()
    dispatch(setReloadFinancialYear(false));
  }, [reloadFinancialYear, tableFilters, isUpdateSuccess, selectedPrimaryClient]);
  const handleStatusUpdate = async (item, newStatus) => {
    if (item.status !== newStatus) {
      try {
        const payLoad = {
          fy: item._id,
          status: newStatus,
          clientName: item.client_id,
          companyName: item.company_id,
          page: pagination.current,
          filters: tableFilters,
          all: false,
        };
        let res = await updateFinancialYear(payLoad);
        if (res) {
          message.success("Status updated successfully");
          dispatch(setReloadFinancialYear(true));

        }
      } catch {
        message.error("Some error occured while updating status");
      }
    }
    return;
  };

  const assigneeFilters = (dat) => {
    const filteredUsers = users?.data?.filter((e) => {
      return e.role === user_role.ADMIN ||
        e?.company_ids?.some((f) => f._id === selectedCompany?._id)
    }
    );

    let map = {};
    let filter = [];

    filteredUsers?.forEach((e) => {
      let name = `${e.first_name} ${e.last_name}`;
      let id = e._id;
      if (!map[name]) {
        map[name] = 1;
        filter.push({ text: name, value: id });
      }
    });
    // setShowData(filter)
    return filter;
  };

  const columnData = [
    {
      title: `Financial Year (${financialYears?.data?.length})`,
      key: "start",
      render: (record) => (
        record?.fy_status === 'PROPOSED' ? (
          <div style={{ display: 'flex', cursor: 'pointer' }}>
            <p style={{ fontWeight: "600" }} className="pointer m-2">
              {moment(record?.start).format('YYYY')}-{moment(record?.end).format('YY')}
            </p>
            <ProposedBadge content="proposed" color="#CC9900" bgColor="rgba(204, 153, 0, 0.1)" />
          </div>
        ) : (
          <p style={{ fontWeight: "600", cursor: 'pointer' }} className="pointer">
            {moment(record?.start).format('YYYY')}-{moment(record?.end).format('YY')}
          </p>
        )

      ),

      onCell: (record) => {
        return {
          onClick: (event) => {
            if (selectedPrimaryClient?._id) {
              navigate(
                `/${companyName}/${selectedPrimaryClient?._id}/${clientName}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}?${user?.role !== user_role.PRIMARY_CLIENT ? 'tab=queries' : 'tab=primary_client_queries'}`
                // `/${companyName}/${clientName}/?fy=${record?._id}&entity=${record?._id}&company=${selectedCompany?._id}`
              );
              return;
            }
            navigate(
              `/${companyName}/${clientName}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}?${user?.role !== user_role.PRIMARY_CLIENT ? 'tab=queries' : 'tab=primary_client_queries'}`
              // `/${companyName}/${clientName}/?fy=${record?._id}&entity=${record?._id}&company=${selectedCompany?._id}`
            );
          },
        }
      }

    },

    {
      title: `Queries`,
      key: "queries",
      render: (record) => {
        const currentquery = query?.filter(data => data?.financialYear?._id === record?._id && data.type !== query_type.TRANSACTIONAL);
        return <div style={{ cursor: 'pointer', height: '100%', width: '100%', textAlign: 'center' }}>
          <p > {currentquery?.length} </p>
        </div>
      },
      onCell: (record) => {
        return {
          onClick: (event) => {
            if (selectedPrimaryClient?._id) {
              navigate(`/${companyName}/${selectedPrimaryClient?._id}/${clientName}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}?${user?.role !== user_role.PRIMARY_CLIENT ? 'tab=queries' : 'tab=primary_client_queries'}`);
              return
            }
            navigate(
              `/${companyName}/${clientName}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}?${user?.role !== user_role.PRIMARY_CLIENT ? 'tab=queries' : 'tab=primary_client_queries'}`
              // `/${companyName}/${clientName}/?fy=${record?._id}&entity=${record?._id}&company=${selectedCompany?._id}`
            );
          },
        }
      },
    },
    {
      title: "Priority",
      key: "priority",
      sorter: (a, b) => {
        const aa = priority_order.indexOf(a?.priority);
        const bb = priority_order.indexOf(b?.priority);
        return aa - bb;
      },
      render: (record) => (
        <FYPrioritySelector
          item={{
            _id: record?._id,
            priority: record?.priority,
            client_id: record?.client?._id,
            company_id: record?.client?.company
          }}
          handlePriorityUpdate={handlePriorityUpdate}
          isDisabled={user?.role === (user_role?.COMPANY || user_role.PRIMARY_CLIENT)}
        />
      ),
      filters: priorityFilters,
      onFilter: (value, record) => record?.priority === value,
    },
    ...(user?.role !== user_role.PRIMARY_CLIENT
      ? [
        {
          title: "Status",
          key: "status",
          sorter: (a, b) => {
            const aa = fy_status_order?.indexOf(a?.status);
            const bb = fy_status_order?.indexOf(b?.status);
            return aa - bb;
          },
          render: (record) => (
            <FYStatusSelector
              item={{
                _id: record?._id,
                status: record?.status,
                client_id: record?.client?._id,
                company_id: record?.client?.company
              }}
              handleStatusUpdate={handleStatusUpdate}
              isDisabled={user?.role === user_role?.COMPANY}
            />
          ),
          filters: statusFilters,
          onFilter: (value, record) => record?.status === value,
        },
        {
          title: "Period Type",
          key: "period_type",
          dataIndex: "period_type",
          sorter: false,
          filters: periodFilters,
          filterMultiple: true,
          render: (value) => value,
          onFilter: (value, record) => record.period_type === value

        },
        {
          title: "FY Type",
          key: "fy_type",
          dataIndex: "fy_type",
          sorter: false,
          filters: fyTypeFilters,
          filterMultiple: true,
          render: (value) => value,
          onFilter: (value, record) => record.fy_type === value

        },
        {
          title: "Assigned To",
          key: "assigned_to",
          render: (record) => (
            <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              onClick={() => setFyy(record?._id)}
            >
              <Fyassign
                query={{
                  assigned_to: {
                    first_name: record?.assigned_to?.first_name,
                    last_name: record?.assigned_to?.last_name,
                  },
                  company: company?._id,
                }}
                className="p-2"
                handleFyUpdate={handleFyUpdate}
                role={""}
              />
            </div>
          ),
          defaultFilteredValue: tableFilters?.assigned_to,
          filters: assigneeFilters(showData),
          filterMultiple: true,
          // onFilter: (value, record) =>
          //   `${record?.assigned_to?.first_name} ${record?.assigned_to?.last_name}` === value,
        },
      ]
      : []),

    ...(user?.role === user_role?.ADMIN ? [{
      title: `Trash`,
      key: "trash",
      render: (record) => (
        <div>
          <Button
            type='text'
            className='ms-3'
            onClick={() => {
              setPermissionModalOpen(record)
            }}
          >
            <DeleteOutlined size={15} />
          </Button>
        </div>
      )
    }] : [])
  ];

  // async function initClientAndQuery() {
  //   if (companyName) {
  //     try {
  //       setLoading(true);
  //       // let clients = await dispatch(await getClients(selectedCompany._id));
  //       // await dispatch(await getFinancialYears(Array.isArray(clients) && clients.length ? clients.map(e => e._id) : []));
  //       // let get = await dispatch(getQueries(selectedCompany._id));
  //       // setQueries(get)
  //     } catch (e) {
  //       message.error('Some error occurred while fetching data');
  //       console.error(e);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // }

  async function deleteFinancialyear() {
    const payload = {
      client: client._id,
      page: pagination.current,
      filters: tableFilters,
      fy: permissionModalOpen?._id,
    };
    let data = await deleteFy(payload);
    if (data.status === 200) {
      if (Math.ceil(data?.data?.totalFinancialYears / 10) <= pagination?.current && pagination?.current > 1) {
        setPagination((prev) => {
          let newdata = {
            ...prev,
            total: data?.data?.totalFinancialYears,
            current: Math.ceil(data?.data?.totalFinancialYears / 10),
          }
          return newdata
        });
        message.success('Financial Year deleted successfully');
      }
      else {
        setPagination((prev) => {
          let newdata = {
            ...prev,
            total: data?.data?.totalFinancialYears,
          }
          return newdata
        });
        message.success('Financial Year deleted successfully');
      }
    }
    setPermissionModalOpen(null);
  }

  useEffect(() => {
    if (reloadFY && client) {
      financialYearCache.refetch();
      dispatch(setReloadFinancialYear(false))
      setIsLoading(false)
    }
  }, [reloadFY, companyName, client]);



  return (
    <>
      {
        isLoading ? <Loader /> :
          <div>
            <Row gutter={[24, 0]}>
              <Col xs={24} className="mb-<FySidebar 24">
                <Card
                  className='header-solid h-full'
                  variant="outlined"
                  style={{ body: { paddingTop: 0 } }}
                  title={[
                    <div className='d-flex flex-col'>
                      <div className="flex-fill search d-flex">
                        <div className="d-flex flex-fill justify-content-center">
                          <SearchBox all={financialYears?.data} setshow={setShow} name={placeholder} setFilter={setTableFilters} />
                        </div>
                      </div>
                    </div>
                  ]}
                >
                  <Col>
                    {
                      <Table
                        onRow={(record, rowIndex) => {
                          return {
                            onClick: async (event) => {
                              // await dispatch(changeSelectedFY(record));
                            },
                          };
                        }}
                        columns={columnData}
                        dataSource={financialYears?.data?.map(e => ({ ...e, key: e._id }))}
                        pagination={{
                          current: pagination?.current,
                          pageSize: pagination?.pageSize,
                          total: pagination?.total,
                          showSizeChanger: false,
                          // onChange: handleTableChange
                        }}
                        sortDirections={["descend", "ascend"]}
                        loading={isLoading}
                        onChange={handleTableChange}
                      />
                    }
                  </Col>
                </Card>
              </Col>
            </Row>
            <PermissionModal
              visible={permissionModalOpen !== null}
              setVisible={setPermissionModalOpen}
              onSuccess={deleteFinancialyear}
              // onSuccess={() => 
              //   deleteFinancialyear(permissionModalOpen?._id)
              // }
              child={
                <p>Are you sure you want to delete this <b>financial year</b>? This will delete all the  <b>Queries</b>, and <b>Attachments</b> related to this Financial year.</p>
              }
            />
          </div>
      }
    </>
  );
}